// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.b-fleet-filters__body[data-v-019f026a] {
  max-height: 270px;
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/js/vue/components/leaseitnow/FilterEdition.vue","webpack://./FilterEdition.vue"],"names":[],"mappings":"AAEE;EACE,iBAAA;EACA,cAAA;ACDJ","sourcesContent":["\r\n.b-fleet-filters {\r\n  &__body {\r\n    max-height: 270px;\r\n    overflow: auto;\r\n  }\r\n}\r\n",".b-fleet-filters__body {\n  max-height: 270px;\n  overflow: auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
